import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";

import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";

import {
  getTiposNotas,
  getTiposNotasPorEstadoPresupuesto,
  getTiposNotasTodas,
  postNotaPresupuesto,
} from "../../../../actions/autorizaciones/Autorizaciones";
import { AUTORIZACIONES_BANDEJAS, AUTORIZACIONES_PRESUPUESTOS_ESTADOS, AUTORIZACIONES_TIPOS_NOTAS } from "../../../../utils/constants";
import { startAlerta } from "../../../../actions/ui/alertas";

export const ModalNotasPresupuesto = (props) => {
  const dispatch = useDispatch();

  const { tiposNotas = [] } = useSelector((state) => state.autorizaciones);
  const { idUsuario } = useSelector((state) => state.auth);

  const [idTipoNota, setIdTipoNota] = useState(
    !!props.nota ? props.nota.idTipoNota : AUTORIZACIONES_TIPOS_NOTAS.PRIVADA
  );
  const [descripcion, setDescripcion] = useState(
    !!props.nota ? props.nota.descripcion : ""
  );
  const [error, setError] = useState(false);

  useEffect(() => {
    if (props.disabled || props.nota?.idNota) {
      dispatch(getTiposNotasTodas());
    } else if (props.idEstadoPresupuesto) {
      dispatch(getTiposNotasPorEstadoPresupuesto(props.idEstadoPresupuesto));
    } else {
      dispatch(getTiposNotas());
    }
  }, []);

  useEffect(() => {
    if (tiposNotas.length === 1 && props.nota?.idNota === undefined)
      setIdTipoNota(tiposNotas[0].idTipoNota);
  }, [tiposNotas]);

  const onChangeTextAreaHandler = (e) => {
    const hayError =
      e?.target?.value?.length === 0 || e?.target?.value?.length === 500;
    setError(hayError);
    setDescripcion(e.target.value);
  };
  

  const saveNote = (nota, idPresupuesto, method, close, showSuccess) => {
    dispatch(postNotaPresupuesto(nota, idPresupuesto, method, close, showSuccess));
  }

  const onSubmitHandler = (e) => {
    e.preventDefault();

    if (props.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION
      && (props.idEstadoPresupuestoDevolucion === props.presupuestoSeleccionado?.idEstadoPresupuesto &&
        props.presupuestoSeleccionado?.idBandejaAutorizacion !== AUTORIZACIONES_BANDEJAS.COMPRAS)
    ) {
      dispatch(
        startAlerta(
          "El presupuesto ya se encuentra pendiente",
          "error",
          "Error"
        )
      );
    } else {

      let nota = null;
      if (!props.nota) {
        nota = {
          idPresupuesto: props.idPresupuesto,
          idTipoNota,
          descripcion,
        };
      } else {
        nota = {
          idNota: props.nota?.idNota,
          descripcion,
        };
      }

      const method = !props.nota ? "POST" : "PUT";

      if (props.privada === true) {
        props.guardar(() => saveNote(nota, props.idPresupuesto, method, props.close, false));
      } else {
        dispatch(postNotaPresupuesto(nota, props.idPresupuesto, method, props.close, true));
      }
    }

  };

  const bntSaveDisabled = (props.disabled || props.nota?.idNota) && props.nota?.idUsuario !== idUsuario;
  const tipoNotaDisabled = !!props.nota && props.nota?.idUsuario !== idUsuario;
  //const detalleDisabled = (props.desdeIngresoSolicitud && props.titulo !== "Agregar Nota") || (props.nota?.idUsuario !== idUsuario && props.nota?.idUsuario !== null);

  return (
    <Dialog fullWidth maxWidth="sm" open={props.open} onClose={props.close}>
      {!props.disabled && props.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION
        && <DialogTitle>Elegir estado de Devolucion</DialogTitle>}
      {!props.disabled && props.idEstadoPresupuesto === AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION
        && (<Grid container spacing={2}>
          <Grid item xs={1} sm={1} md={2} lg={3} />
          <Grid item xs={10} sm={10} md={8} lg={6}>
            <RadioGroup
              row
              style={{ justifyContent: "space-evenly" }}
              value={props.idEstadoPresupuestoDevolucion?.toString()}
              onChange={(e) => {
                props.setIdEstadoPresupuestoDevolucion(parseInt(e.target.value));
              }}
            >
              <FormControlLabel
                label={"CAB (Devolución)"}
                value={AUTORIZACIONES_PRESUPUESTOS_ESTADOS.DEVOLUCION.toString()}
                control={<Radio />}
                disabled={false}
              />
              <FormControlLabel
                label={"Auditoría (Pendiente)"}
                value={AUTORIZACIONES_PRESUPUESTOS_ESTADOS.PENDIENTE.toString()}
                control={<Radio />}
                disabled={false}
              />
              <FormControlLabel
                label={"Compras (Pendiente)"}
                value={AUTORIZACIONES_PRESUPUESTOS_ESTADOS.COMPRAS.toString()}
                control={<Radio />}
                disabled={false}
              />
            </RadioGroup>
          </Grid>
          <Grid item xs={1} sm={1} md={2} lg={3} />
        </Grid>)}
      <DialogTitle>{props.titulo}</DialogTitle>
      <DialogContent>
        <ValidatorForm onSubmit={onSubmitHandler}>
          <Grid container spacing={2}>
            <Grid item xs={1} sm={1} md={2} lg={3} />
            <Grid item xs={10} sm={10} md={8} lg={6}>
              {Array.isArray(tiposNotas) && tiposNotas?.length > 0 && (
                <SelectValidator
                  fullWidth
                  label="Tipo de Nota"
                  name="idTipoNota"
                  value={idTipoNota}
                  disabled={tipoNotaDisabled}
                  onChange={(e) => setIdTipoNota(e.target.value)}
                  validators={["required"]}
                  errorMessages={["Este campo es requerido"]}
                >
                  {Array.isArray(tiposNotas) &&
                    tiposNotas?.length > 0 &&
                    tiposNotas
                      /*.filter((tipoNota) => (props.privada ? tipoNota.idTipoNota === 1 : true)) nota: ahora filtra el back*/
                      .map((tipoNota) => (
                        <MenuItem key={tipoNota.idTipoNota} value={tipoNota.idTipoNota}>
                          {tipoNota.descripcion}
                        </MenuItem>
                      ))}
                </SelectValidator>
              )}
            </Grid>
            <Grid item xs={1} sm={1} md={2} lg={3} />
          </Grid>
          <Grid container spacing={2} style={{ margin: "2rem 0" }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                multiline
                rows={4}
                label="Nota"
                name="descripcion"
                value={descripcion}
                disabled={props.desdeIngresoSolicitud && props.titulo !== "Agregar Nota"}
                onChange={onChangeTextAreaHandler}
                error={error}
                helperText={error && "Este campo es requerido"}
              />
            </Grid>
          </Grid>
          <div
            style={{
              margin: "1rem 0",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
            }}
          >
            <Button variant="contained" color="primary" onClick={props.close}>
              Cancelar
            </Button>
            <Button type="submit" variant="contained" disabled={bntSaveDisabled} color="primary">
              Guardar
            </Button>
          </div>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};
